module.exports = __webpack_public_path__ + "img/dsci0062.4c973d2e.jpg";